module.exports = __webpack_public_path__ + "img/bg.9b20121f.png";